<template>
    <div>
        <div id="commentsBtn">
            <a v-if="isLoggedIn" href="#" @click.prevent="showForm">
                <icon icon="comments" size="2x"/>
            </a>
            <a v-else href="mailto:feedback@pimblr.com" title="feedback@pimblr.com">
                <icon icon="comments" size="2x"/>
            </a>
        </div>


        <div class="modal fade" :class="{show: show}" :style="modalStyle" id="feedbackModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Give us some Feedback!</h5>
                        <button type="button" class="close" aria-label="Close" @click.prevent="hideForm">
                            <icon icon="times"/>
                        </button>
                    </div>
                    <div class="modal-body">
                        <h3>We love your Feedback!</h3>
                        <p>No matter if it's good or bad! We really would like to know what you are thinking about Pimplr.
                            So, go on, just send us rating and/or a few lines of feedback.</p>
                        <form>
                            <!--
                            <div class="form-group">
                                <label>Name</label>
                                <input type="text" class="form-control" v-model="formData.name"/>
                            </div>
                            <div class="form-group">
                                <label>E-Mail</label>
                                <input type="text" class="form-control" v-model="formData.email"/>
                            </div>
                            -->
                            <div class="form-group">
                                <label>How do your like pimblr?</label>
                                <div class="stars">
                                    <span
                                      v-for="i in 5"
                                      class="star"
                                      :class="{active: starActive(i) || starOver(i), selected: starActive(i)}"
                                      @click.prevent="setStars(i)"
                                      @mouseover="setStarOver(i)"
                                      @mouseout="setStarOut(i)">
                                        <icon icon="star" :collection="starActive(i)?'fas':'fal'" size="2x"/>
                                    </span>
                                </div>
                            </div>

                            <!--
                            <div class="form-group">
                                <label>Topic</label>
                                <input type="text" class="form-control" v-model="formData.subject"/>
                            </div>
                            -->
                            <div class="form-group">
                                <label>Message</label>
                                <textarea class="form-control" rows="4" v-model="formData.message"></textarea>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal" @click.prevent="hideForm">Close</button>
                        <indicator-button class="btn btn-primary" :click="sendForm" :is-loading="loading">Send</indicator-button>

                    </div>
                </div>
            </div>
        </div>
        <div v-if="show" class="modal-backdrop fade show"></div>

    </div>
</template>

<script>

    import Icon from '../ui/Icon';
    import IndicatorButton from '../ui/buttons/IndicatorButton'

    export default {
        name: '',
        data() {
            return {
                show: false,
                loading: false,
                starsOver: 0,
                formData:{
                    name: '',
                    email: '',
                    subject: '',
                    message: '',
                    stars: 0
                }

            }
        },
        computed:{
            modalStyle(){
                return this.show ? 'display: block' : '';
            },
            isLoggedIn(){
                return this.$store.state.user.isLoggedIn;
            }
        },
        mounted(){
            this.$bus.$on('feedback.open', (message)=>{
                 if(message) this.formData.message = message;
                 this.showForm();
            });
        },
        methods: {
            setStars(num){
                this.formData.stars = num;
            },
            starActive(i){
                return (i<=this.formData.stars);
            },
            starOver(i){
              return (i<=this.starsOver);
            },
            setStarOver(i) {
                this.starsOver = i;
            },
            setStarOut(i) {
              this.starsOver = 0;
            },
            showForm(){
                this.show = true;
                this.$bus.$emit('modal.open', 'defaultModal');
            },
            hideForm(){
                this.show = false;
                this.$bus.$emit('modal.close', 'defaultModal');
                this.formData = {
                    name: '',
                    email: '',
                    subject: '',
                    message: '',
                    stars: 0
                }
            },
            sendForm(){
                this.loading = true;

                this.$api.sendFeedback(this.formData)
                    .catch((err)=>{
                        this.loading = false;
                    })
                    .then(()=>{
                        this.$bus.$emit('success', 'Thank you! Your message was sent!')
                        this.loading = false;
                        this.hideForm();
                    });

            }
        },
        components:{
            Icon,
            IndicatorButton
        }
    }
</script>

<style lang="sass" scoped>

    @import '../../assets/sass/vars'

    #commentsBtn
        position: fixed
        bottom: 1em
        left: 1em
        z-index: 100
        background-color: #EEE
        padding: 7px
        border-radius: 7px
        border: 1px solid #CCC
        opacity: 0.8

        &:hover
          opacity: 1

        svg
          filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.8))

    .close
        cursor: pointer

    .star
        display: inline-block
        margin-right: .5em
        color: #AAAAAA
        cursor: pointer
        transition: transform 500ms ease-in-out

        &.active
            color: $colorPrimary

        &.selected
            transform: rotateZ(360deg)

</style>



// WEBPACK FOOTER //
// src/components/layout/FeedbackWidget.vue